<template>
    <section class="my-3" id="services">
        <div class="row container-fluid m-auto">
            <div class="col-md-12 bg-orange text-center text-white py-4 border-b05">
                <h2>{{ title }}</h2>
            </div>
        </div>
        <div class="row container-fluid mx-auto my-1" :class="{'flex-row-reverse': item.id % 2 === 0}" v-for="item in servicesData">
            <div class="col-md-4 bg-orange text-center text-white p-4">
                <h3>{{ item.name }}</h3>
            </div>
            <component :is="item.isList ? 'ul' : 'div'" :class="['col-md-8 p-4 bg-white mb-0', {'pl-4': item.isList}]" v-html="item.description"></component>
        </div>
    </section>
</template>

<script>
import { handleTitle } from '@/composable/handleTitle'
import bbCodeParser from "js-bbcode-parser";

export default {
    props: ['data'],
    data() {
        return {
            title: handleTitle('services'),
            servicesData: this.handleServices(),
            description: bbCodeParser.parse(this.data.about[0].description),
        }
    },
    methods: {
        handleServices() {
            const services = Object.values(this.data.services)
            return services.map(item => {
                const description = bbCodeParser.parse(item.description)
                return {
                    id: item.id,
                    name: item.name,
                    description,
                    isList: description.includes('<li>')
                }
            })
        }
    }
}
</script>

<style scoped>
.pl-4 {
  padding-left: 40px !important;
}
</style>
